export default __webpack_public_path__ + "static/media/SF Compact Text Bold.4c36696d.ttf";